class ZitatAPI {
  constructor (url, token) {
    this.url = url
    this.token = token
  }

  updateBooks () {
    return postData(this.url + '/books/update/', this.token, {})
  }

  getAllBooks () {
    return getAllData(this.url + '/books/', this.token)
  }
  getAllQuotes () {
    return getAllData(this.url + '/quotes/', this.token)
  }
  addBook (book) {
    return postData(this.url + '/books/', this.token, book)
  }
  addQuote (quote) {
    return postData(this.url + '/quotes/', this.token, quote)
  }
  updateBook (book) {
    return putData(`${this.url}/books/${book.id}/`, this.token, book)
  }
  updateQuote (quote) {
    return putData(`${this.url}/quotes/${quote.id}/`, this.token, quote)
  }
  deleteBook (book) {
    return deleteData(`${this.url}/books/${book.id}/`, this.token)
  }
  deleteQuote (quote) {
    return deleteData(`${this.url}/quotes/${quote.id}/`, this.token)
  }
  getUser () {
    return request(`${this.url}/user/`, this.token)
  }
  login (data) {
    return postData(this.url + '/auth/login/', null, data).then((data) => {
      return data.key
    })
  }
  logout () {
    return postData(this.url + '/auth/logout/', this.token)
  }
  changePassword (data) {
    return postData(this.url + '/auth/password/change/', this.token, data)
  }
  register (data) {
    return postData(this.url + '/auth/registration/', data)
  }
}

function request (url = '', token, method = 'GET', data = null) {
  const params = {
    method: method,
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  }
  if (token !== null) {
    params.headers['Authorization'] = 'Token ' + token
  }
  if (data !== null) {
    params.body = JSON.stringify(data)
  }
  return window.fetch(url, params).then((response) => {
    if (response.status === 204) {
      return {}
    }
    if (response.status < 300) {
      return response.json()
    }

    return response.json().then((data) => {
      const err = new Error('Request failed')
      err.data = data
      throw err
    })
  })
}

function postData (url = '', token, data) {
  return request(url, token, 'POST', data)
}

function deleteData (url = '', token) {
  return request(url, token, 'DELETE')
}

function putData (url = '', token, data = {}) {
  return request(url, token, 'PUT', data)
}

function getAllData (url = '', token, result = [], progress = null) {
  return new Promise((resolve, reject) => {
    request(url, token).then((data) => {
      result = [...result, ...data.results]
      if (data.next) {
        if (progress) {
          progress(result)
        }
        getAllData(data.next, token, result).then(resolve).catch(reject)
      } else {
        resolve(result)
      }
    })
  })
}

export default ZitatAPI
